module.exports = __webpack_public_path__ + "static/media/chen2026semantic.b80ba949.gif";